module.exports={
    errorCode: {
        search:'搜索',
        sure:'确定',
        title:'错误码',
        table:{
        	index:'序号',
        	mac:'标签Mac',
        	code:'code',
            createTime:'createTime',
            opcode:'opcode'
        },
        hintMsg:{
            queryErrorCodeFail:'查询错误码失败'
        },
        operationType:[{  //操作类型
            value: 0,
            label:'全部错误码'
        },
        // {
        //     value:'20000001',
        //     label:'标签数据MDU格式错误'
        // },{
        //     value:'10000000',
        //     label:'广播参数错误'
        // },{
        //     value:'10000001',
        //     label:'图片尺寸错误'
        // },{
        //     value:'10000002',
        //     label:'屏幕硬件错误'
        // },{
        //     value:'10000003',
        //     label:'LED参数错误'
        // },{
        //     value:'10000004',
        //     label:'无效指令'
        // },{
        //     value:'30000200',
        //     label:'Base internal error code'
        // },{
        //     value:'30000201',
        //     label:'Out of memory'
        // },{
        //     value:'30000202',
        //     label:'Central modules are broken, less than two central modules are available'
        // },
        {
            value: 10000000,
            label:'10000000'
        },{
            value: 10000001,
            label:'10000001'
        },{
            value: 10000002,
            label:'10000002'
        },{
            value: 10000003,
            label:'10000003'
        },{
            value: 10000004,
            label:'10000004'
        },{
            value: 20000001,
            label:'20000001'
        },{
            value: 30000200,
            label:'30000200'
        },{
            value: 30000201,
            label:'30000201'
        },{
            value: 30000202,
            label:'30000202'
        },{
            value: 30000203,
            label:'30000203'
        },{
            value: 30000204,
            label:'30000204'
        },{
            value: 30000205,
            label:'30000205'
        },{
            value: 30000206,
            label:'30000206'
        },{
            value: 30000207,
            label:'30000207'
        },{
            value: 30000208,
            label:'30000208'
        },{
            value: 30000209,
            label:'30000209'
        },{
            value: 30000210,
            label:'30000210'
        },{
            value: 30000501,
            label:'30000501'
        },{
            value: 30000502,
            label:'30000502'
        },{
            value: 30000503,
            label:'30000503'
        },{
            value: 30000504,
            label:'30000504'
        },{
            value: 30000505,
            label:'30000505'
        },{
            value: 30000506,
            label:'30000506'
        },{
            value: 30000507,
            label:'30000507'
        },{
            value: 30000508,
            label:'30000508'
        },{
            value: 30000509,
            label:'30000509'
        },{
            value: 30000510,
            label:'30000510'
        },{
            value: 30000520,
            label:'30000520'
        },{
            value: 30000521,
            label:'30000521'
        },{
            value: 30000522,
            label:'30000522'
        },{
            value: 30000523,
            label:'30000523'
        },{
            value: 30000524,
            label:'30000524'
        },{
            value: 30000525,
            label:'30000525'
        },{
            value: 30000526,
            label:'30000526'
        },{
            value: 30000527,
            label:'30000527'
        },{
            value: 30000528,
            label:'30000528'
        },{
            value: 30000529,
            label:'30000529'
        },{
            value: 30000530,
            label:'30000530'
        }]
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/errorCode.js